<template>
  <div class="p-postEditor__itemWrapper">
    <div v-show="editingItemIndex !== index" @click="editItem">
      <external-link-item-preview :item="item" />
    </div>
    <item-form v-if="editingItemIndex === index" :item="item">
      <div class="px-5">
        <v-select
          :value="editingItemable.style"
          :items="items"
          class="body-2"
          item-text="style"
          style="width: 300px"
          item-value="value"
          dense
          single-line
          @change="updateEditingItemable($event, 'style')"
        />
        <v-text-field
          :value="editingItemable.sentence"
          :rules="[presenceValidation]"
          label="リンクタイトル"
          style="width: 400px"
          required
          @input="(value) => updateEditingItemable(value, 'sentence')"
        />
        <v-text-field
          :value="editingItemable.url"
          :rules="[presenceValidation, urlValidation]"
          label="URL"
          autofocus
          required
          @input="(value) => updateEditingItemable(value, 'url')"
        />
        <v-switch
          v-model='nofollowSwitch'
          label="nofollow属性を付与する"
        ></v-switch>
      </div>
    </item-form>
  </div>
</template>

<script>
import itemUtilsMixin from '@/mixins/item_utils'
import ExternalLinkItemPreview from './previews/ExternalLinkItemPreview'
import formValidationUtils from '@/mixins/form_validation_utils'

export default {
  name: 'ExternalLinkItem',
  components: { ExternalLinkItemPreview },
  mixins: [itemUtilsMixin, formValidationUtils],
  data: () => {
    return {
      items: [
        { style: '通常外部リンク', value: 'normal' },
        { style: 'アフィリエイトリンク', value: 'affiliate' }
      ]
    }
  },
  computed: {
    nofollowSwitch: {
      get () {
        return !this.editingItemable.follow
      },
      set (value) {
        this.updateEditingItemable(!value, 'follow')
      }
    }
  }
}
</script>

<style scoped></style>
